import {
  RawDraftContentBlock,
  RawDraftEntity,
  RawDraftEntityRange,
  RawDraftInlineStyleRange,
} from '@msd-npm-gmc-dev/gmc-dc-assembler-draftjs2lexical';
import { DraftEntityData } from './types';

type TRanges = RawDraftEntityRange & RawDraftInlineStyleRange;

type TCombination = {
  position: number[];
  style: string[] | null;
  type: string | null;
  data?: unknown;
};

const createCombinationsReducer = (
  entityMap: { [key: string]: RawDraftEntity },
) => (acc: TCombination[], curr: TRanges): TCombination[] => {
  const index = acc.length > 0 && curr.style
    ? acc.findIndex(
      el => el.position[0] === curr.offset && el.position[1] === curr.length,
    )
    : -1;

  if (index >= 0) {
    acc[index] = {
      ...acc[index],
      style: [...(acc[index].style || []), curr.style],
    };

    return acc;
  }

  const child: TCombination = {
    type: curr.key !== undefined ? entityMap[curr.key].type : null,
    style: curr.style ? [curr.style] : null,
    position: [curr.offset, curr.length],
    data: curr.key !== undefined ? entityMap[curr.key].data : null,
  };

  return [...acc, child];
};

export function extractBlockEntities(
  block: RawDraftContentBlock,
  entityMap: { [key: string]: RawDraftEntity },
): DraftEntityData[] {
  const { inlineStyleRanges, entityRanges } = block;

  const combinations = [...inlineStyleRanges, ...entityRanges]
    .reduce(createCombinationsReducer(entityMap), [] as TCombination[]);

  const breakponts = combinations.reduce(
    (set, item) => {
      const { position: [start, length] } = item;
      set.add(start);
      set.add(start + length);

      return set;
    },
    new Set([0, block.text.length]),
  );
  const offsets = [...breakponts].sort((a, b) => (a - b));
  offsets.pop();

  const chunks: DraftEntityData[] = [];

  offsets.forEach((offset, i: number) => {
    const styles = combinations.reduce((acc, curr) => {
      const start = curr.position[0];
      const end = start + curr.position[1];

      return curr.style && (start <= offset && offset < end)
        ? [...acc, ...curr.style]
        : acc;
    }, []);

    const text = block.text.slice(offset, offsets[i + 1]);
    const entityRange = entityRanges.find(range => range.offset <= offset && (range.offset + range.length) > offset);

    if (entityRange) {
      const { type, data } = entityMap[entityRange.key];
      chunks.push({ styles, text, type, data });
    } else {
      chunks.push({ styles, text });
    }
  });

  return chunks;
}
